import { FunctionComponent, memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../../context';
import { StoryCardThreadContent } from '../../../../services';
import { CardContainer } from '../CardContainer';
import { RightSideStoryCardProps } from '../RightSideStoryCard';

import classes from './Thread.module.scss';

export const Thread: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  const { t } = useTranslation();

  const { localiseKey } = useContext(ConfigContext).config.elements.card.thread;

  const { content } = card;

  const { title } = content as StoryCardThreadContent;

  return (
    <CardContainer card={card}>
      <div className={classes['thread']}>
        <div className={classes['thread__discussion']}>
          {t(`${localiseKey ?? 'common.discussion'}`)}
        </div>
        {title && <div className={classes['thread__title']}>{title}</div>}
      </div>
    </CardContainer>
  );
});
